import { render } from "./ScrollIndicator.vue?vue&type=template&id=2113de3b"
import script from "./ScrollIndicator.vue?vue&type=script&lang=js"
export * from "./ScrollIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__